import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ProductResultItemModel} from "../../shared/models/search/results/items/product-result-item.model";
import {SearchResultModel} from "../../shared/models/search/results/search-result.model";
import {ApiResultDispatcherService} from "../../shared/services/api/api-result-dispatcher.service";
import {ApiService} from "../../shared/services/api/api-service";
import {WindowRefService} from "../../shared/services/window-ref.service";
import {CollectionSearchParamsModel} from "../models/collection-search-params.model";
import {CollectionResultsFilter} from "../models/search-results/filters/collection-results-filter";
import {CollectionSearchParamsFactoryService} from "./factories/collection-search-params-factory.service";
import {ShoppingHistoryService} from "../../shared/services/shopping-history.service";

@Injectable({
    providedIn: "root"
})
export class CollectionSearchService {
    private API_BASE_URL = "/umbraco/api";

    private API_GET_SEARCH_RESULTS_URL = `${this.API_BASE_URL}/advancedSearchApi/getCollectionSearchResult`;

    public constructor(
        private windowService: WindowRefService,
        private apiService: ApiService,
        private apiDispatcherService: ApiResultDispatcherService,
        private searchParamsFactory: CollectionSearchParamsFactoryService,
        private shoppingHistoryService: ShoppingHistoryService
    ) {
    }

    public getSearchResult(params: CollectionSearchParamsModel): Observable<SearchResultModel<ProductResultItemModel, CollectionResultsFilter>> {
        this.updateQueryString(params);
        this.shoppingHistoryService.saveCurrentPage().subscribe(r => {});

        let http = this.apiService.get<SearchResultModel<ProductResultItemModel, CollectionResultsFilter>>(
            this.API_GET_SEARCH_RESULTS_URL, {
                searchParams: JSON.stringify(params)
            }
        );

        http = this.apiDispatcherService.dispatchNetworkErrorNotification(http);

        return http;
    }

    private updateQueryString = (params: CollectionSearchParamsModel) => {
        const serializedParams = this.searchParamsFactory.serialiseToQueryString(params);
        WindowRefService.setQueryString(serializedParams);
    }
}
